import axios from 'axios';
import moment from 'moment';

import store from '../core/store';
import { setLoggedInStatus, setLoggedInUser} from '../components/generic/actions';
import { session_length, common_app_login_url, non_licensed_categories } from "../config/constants";
import { getEnvConfig } from "./environment";

const config = getEnvConfig();

export const auth = {
    isAuthenticated(token){
        //if we have a new token - destroy the old session if it exist and verify the new token
        if(token){
            axios.post(
                config.token_verification_endpoint,
                {
                    token: token
                }
            )
                .then(function (response) {
                    store.dispatch(setLoggedInUser(response.data));
                    setUserData(response.data);
                    store.dispatch(setLoggedInStatus(true));
                })
                .catch(function (error) {
                    clearUserData();
                    store.dispatch(setLoggedInStatus(false));
                });
        }
        else {
            const user = getUserData();
            if(isLoggedIn(user)){
                store.dispatch(setLoggedInUser(user));
                store.dispatch(setLoggedInStatus(true));
            }
            else {
                clearUserData();
                store.dispatch(setLoggedInStatus(false));
            }
        }
    },
    extend_or_expire(){
        const state = store.getState();

        if(state.loggedInStatus !== 'pending') {
            const user = getUserData();
            if (isLoggedIn(user)) {
                setUserData(user);
            }
            //check if the session has expired and need to be cleared
            else if (
                user
                && user.hasOwnProperty('et')
                && user.et < moment().unix()
            ) {
                clearUserData();
                window.location.href = common_app_login_url;
            }
        }
    },
    getAssociationName(){
        const user = getUserData();

        return (user) ? user.associationName : '';
    },
    tab_disabled(user_level, category_title){
        if (user_level === '6995420741efff5002b5b60686fa7a55'){
            return false;
        }
        if (user_level === 'f6c79590ea24e4374dd2ddb39fc592cf'){
            return (non_licensed_categories.indexOf(category_title) === -1);
        }
        else {
            return true;
        }
    }
};

function isLoggedIn(user) {
    return (
        user
        && user.hasOwnProperty('memberId')
        && user.hasOwnProperty('et')
        && user.et >= moment().unix()
    );
}

function setUserData(user){
    user.et = moment().add(session_length, 'm').unix();
    localStorage.setItem('user', JSON.stringify(user));
}

function getUserData(){
    const user = localStorage.getItem('user');

    return (user) ? JSON.parse(user) : null;
}

function clearUserData(){
    localStorage.removeItem('user');
}


// WEBPACK FOOTER //
// ./src/utils/sessions.js